import { useEffect, useState } from 'react';
import InfoField from '../components/InfoField';
import Tabs from '../components/Tabs';
import { PatientDetail, TabItem } from '../interface/interface';
import PatientOrders from './PatientOrders';
import PatientProducts from './PatientProducts';
import { useNavigate, useParams } from 'react-router-dom';
import { getPatientDetails } from '../service';
import { useAuth } from 'react-oidc-context';
import Loading from '../components/Loading';
import moment from 'moment';
import { transformPhoneNumber } from '../utils/transformPhoneNumber';
import PatientMonthlyLimit from './PatientMonthlyLimit';

export default function DoctorPatientTabs() {
  const { user } = useAuth();
  const { patientId } = useParams();
  const navigateTo = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [patientDetail, setPatientDetail] = useState<PatientDetail>();

  useEffect(() => {
    if (!user?.access_token || !patientId) return;
    setLoading(true);
    getPatientDetails(patientId, 'active', user.access_token).then((data) => {
      if (typeof data === 'number') {
        navigateTo('/404');
        setLoading(false);
        return;
      }

      if (data.patientDetail) {
        setPatientDetail(data.patientDetail);
      }
      setLoading(false);
    });
  }, [patientId, user?.access_token]);

  const tabs: TabItem[] = [
    {
      id: 'tab1',
      label: 'Orders',
      component: <PatientOrders />,
    },
    {
      id: 'tab2',
      label: 'Products',
      component: <PatientProducts />,
    },
    {
      id: 'tab3',
      label: 'Monthly Limits',
      component: <PatientMonthlyLimit />,
    },
  ];

  if (loading) {
    return <Loading />;
  }
  const monthlyLimit = patientDetail?.monthly_limit;
  const monthlyLimitValue =
    monthlyLimit && !isNaN(Number(monthlyLimit)) ? String(monthlyLimit) : '100';

  return (
    <div className="mt-4 bg-white rounded-md p-5 2xl:p-8 shadow mb-10">
      <div className="flex justify-between mt-8 mb-5 border-b border-secondary-cornflowerblue-500">
        <InfoField
          label="Name"
          value={`${patientDetail?.user.first_name} ${patientDetail?.user.last_name}`}
        />
        <InfoField
          label="Date of Birth"
          value={
            patientDetail?.user.dob
              ? moment.utc(patientDetail?.user.dob).format('DD/MM/YYYY')
              : ' - '
          }
        />
        <InfoField
          label="Email"
          value={patientDetail?.user.email ? patientDetail.user.email : ' - '}
          className="w-4/5 break-words"
        />
        <InfoField
          label="Phone"
          value={
            patientDetail?.user.phone
              ? transformPhoneNumber(patientDetail.user.phone.mobile)
              : '-'
          }
        />
        <InfoField label="Monthly limit" value={monthlyLimitValue} />
      </div>

      <Tabs tabs={tabs} />
    </div>
  );
}
